import React, { useCallback } from 'react'
import { Layout, Stack, Card, Button, Text, ButtonGroup } from '@shopify/polaris'
import { getSessionToken } from '@shopify/app-bridge-utils'
import axios from 'axios'

export const ClearAWSCache = (props) => {
  const { app, state } = props
  const click = useCallback(async () => {
    let token = 'dummytoken'
    if (app) {
      token = await getSessionToken(app)
    }
    axios({
      url: `${state.apiEndpoint}/admin/aws/clear-all-cache`,
      method: 'post',
      data: { user: state.user },
      headers: { 'x-wsadmin-api-key': `${token}` },
    })
      .then((res) => {
        if (res.status === 200) {
          window.alert('キャッシュ削除リクエストを送信しました。')
        } else {
          window.alert('キャッシュ削除リクエストの送信に失敗しました。')
        }
      })
      .catch((err) => {
        window.alert('キャッシュ削除リクエストの送信に失敗しました。')
        console.log(err)
      })
  }, [app, state.apiEndpoint, state.user])
  return (
    <Layout.Section>
      <Card sectioned>
        <Stack vertical>
          <Text variant="heading2xl" as="h2">
            AWSのキャッシュ削除
          </Text>
          <Text variant="bodyMd" as="p">
            [キャッシュ削除]ボタンを押すと、AWS
            CloudFrontでホストしている静的コンテンツのキャッシュ削除リクエストを即時に送ります。
            <br />
            削除されるまで最大15分ほどかかります。
          </Text>
          <ButtonGroup>
            <Button primary onClick={click}>
              キャッシュ削除
            </Button>
          </ButtonGroup>
        </Stack>
      </Card>
    </Layout.Section>
  )
}
